import { Tab, Tabs } from "@mui/material"
import React from "react"

const AppTab = ({ tabValue, setTabValue, tabList, marginBottom = 5, indicatorColor }) => {
    return (
        <React.Fragment>
            <Tabs
                value={tabValue}
                onChange={(e, val) => (setTabValue(val))}
                // aria-label="basic tabs example"
                variant="scrollable"
                scrollButtons="auto"
                style={{ borderBottom: '1px solid #E6E6E6', marginBottom: marginBottom, marginTop: 10,}}
                TabIndicatorProps={{ sx: { display: 'none' } }}
                // sx={{
                //     '& .MuiTabs-flexContainer': {
                //         flexWrap: 'wrap',
                //     }
                // }}
            >
                {
                    tabList && tabList.map((tab) => (
                        <Tab
                            key={tab.value}
                            value={tab.value}
                            sx={{ paddingBottom: 1, padding: 0, borderBottom: tabValue === tab.value ? `2px solid ${indicatorColor || '#D13536'}` : '2px solid transparent', transition: 'border-bottom 0.5s ease',  paddingLeft: "20px", paddingRight: "20px" }}
                            label={
                                <div className="d-flex font-size-14" style={{ color: tabValue === tab.value ? '#282828' : '#A0A0A0', textTransform: 'none', fontWeight: 400 }}>
                                    {tab.label}
                                </div>
                            }
                        />
                    ))
                }
            </Tabs>
        </React.Fragment>
    )
}

export default AppTab;